export const ROLE_FIELD = 'role';
